// src/processors/template/template-sourcemap-processor.ts - Source Map Processing
import { XConVitePluginOptions } from '../../types';
import { pathUtils } from '../../utils/path-utils';
import {Logger} from "../../utils/logger";

/**
 * Handles source map generation for template processing
 */
export class TemplateSourceMapProcessor {
    private MagicString: any = null;

    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {
        this.initializeMagicString();
    }

    /**
     * Initialize MagicString if available
     */
    private initializeMagicString(): void {
        try {
            this.MagicString = require('magic-string');
        } catch (e) {
            if (this.options.sourceMap) {
                this.logger.warn('Source maps requested but magic-string not available. Install: npm install magic-string');
            }
        }
    }

    /**
     * Check if MagicString is available
     */
    isMagicStringAvailable(): boolean {
        return this.MagicString !== null;
    }

    /**
     * Create a new MagicString instance
     */
    createMagicString(code: string): any | null {
        if (!this.MagicString) {
            return null;
        }

        try {
            return new this.MagicString(code);
        } catch (error) {
            this.logger.error('Failed to create MagicString:', error);
            return null;
        }
    }

    /**
     * Generate source map from MagicString
     */
    generateSourceMap(magicString: any, id: string): any {
        if (!magicString || !this.options.sourceMap) {
            return null;
        }

        try {
            return magicString.generateMap({
                source: id,
                file: pathUtils.basename(id),
                includeContent: true,
                hires: true // High-resolution mappings for better debugging
            });
        } catch (error) {
            this.logger.error('Failed to generate source map:', error);
            return null;
        }
    }
}